import React, { useEffect, useContext, Dispatch, SetStateAction } from 'react'
import { GlobalContext } from '../../hooks/globalContext';
import apiCall from '../../utility/api';
interface AppData {
	id: number;
	Category: string;
	subcategory: string;
	MetricName: string;
	MetricDesc: string;
	SpecificInfo: string;
	Scores: any;
	UrlPatters: string;
	ApplicationType: string;
	status: string;
}
interface condition {
	formdata: object,
	site: string,
	devicename: string

}

type dataProps = {
	setallDevice?: any;
	setDeviceName?: any;
	scoresFormData?: any;
	setToastMessage?: any;
	setErrorToast?: any;
	overlayName?: string;
	setOverlayOpen?: any
	data?: any;
	func?: any;
	func1?: Dispatch<SetStateAction<AppData | null>> | any;
	searchVal?: string | any;
	pageNo?: number | any;
	setTotalPages?: Dispatch<SetStateAction<number>> | any;
	setTotalRecords?: Dispatch<SetStateAction<number>> | any;
	isFilter?: boolean;
	dropDownValue1?: any;
	dropDownValue2?: any;
	setIsFilter?: any;
	filterArray?: any;
	set_final_data1?: Dispatch<SetStateAction<any>>;
	// savePackageDetails?: any;
	// setSavePackageDetails? :any
	deleteAppMonitored?: any
	setDeleteAppMonitored?: Dispatch<SetStateAction<boolean>> | any;
	setDeleteDisabled?: Dispatch<SetStateAction<boolean>> | any;
	setFormData?: any;
	formdata?: any
	setIsToast?: any
	saveBtnClicked?: Dispatch<SetStateAction<boolean>> | any;
	setsaveBtnClicked?: Dispatch<SetStateAction<boolean>> | any;
	rowID?: any
	isRefresh?: any,
	setIsRefresh?: Dispatch<SetStateAction<boolean>> | any;
	setRefreshToast?: Dispatch<SetStateAction<boolean>> | any;
	setExportDetails?: Dispatch<SetStateAction<boolean>> | any;
	setAppData?:any;
	deviceName?: any
	exportBtnClicked?: any;
	setExportBtnClicked?: any;
	loading?: boolean,
	setRecordState?: Dispatch<SetStateAction<number>> | any;
	setRecordTotalPages?: any
	setLoading?: any
	setSelectedCategoryOptions?: any
	setSelectedSubCategoryOptions?: any
	setSpinnerLoad?: any
}

export const App_Monitored_Func = (props: dataProps) => {
	const contextValue: any = useContext(GlobalContext);
	var tenantName = contextValue.tenantName;

	const getAppMonitoredList = async (whereCondition: any, limit: any, offset: any) => {
		try {
			const {data, status} = await apiCall('/appmonitored/getAppMonitoredList', { ...whereCondition, limit, offset });

			if (status === 'success' && data?.length > 0) {
				if (props.overlayName === 'editMonitoredApp') {
					var res = data[0];

					var cpuUtilisationArr = [];
					var memUtilisationArr = [];
					var netUtilisationArr = [];
					
					props?.setSpinnerLoad(false);
					props.setSelectedCategoryOptions([res.Category]);
					props.setSelectedSubCategoryOptions([res.subcategory]);

					if (res.MetricName == "Process CPU Usage") {
						props.setFormData({
							Category: res.Category,
							Subcategory: res.subcategory,
							ApplicationName: res.MetricDesc,
							ApplicationType: res.ApplicationType,
							UrlPatterns: res.UrlPatters?.split(",")?.map((val: any) => { return ({ urlpatterns: val }) }),
							ApplicationBinaries: res.SpecificInfo,
							cpuUtilisation: JSON.parse(res.Scores).range.map((val: any) => {
								return (
									{
										cpuFrom: val.from,
										cpuTo: val.to,
										cpuScore: val.sc,
										cpuRank: val.rank,
									}
								)
							}),
							memUtilisation: [{
								memFrom: '',
								memTo: '',
								memScore: '',
								memRank: '',
							}],
							netUtilisation: [{
								netFrom: '',
								netTo: '',
								netScore: '',
								netRank: '',
							}],
						});
					} else if (res.MetricName == "Process Memory Usage") {
						props.setFormData({
							Category: res.Category,
							Subcategory: res.subcategory,
							ApplicationName: res.MetricDesc,
							ApplicationType: res.ApplicationType,
							UrlPatterns: res.UrlPatters?.split(",").map((val: any) => { return ({ urlpattern: val }) }),
							ApplicationBinaries: res.SpecificInfo,
							cpuUtilisation: [{
								cpuFrom: '',
								cpuTo: '',
								cpuScore: '',
								cpuRank: '',
							}],
							memUtilisation: JSON.parse(res.Scores).range.map((val: any) => {
								return (
									{
										memFrom: val.from,
										memTo: val.to,
										memScore: val.sc,
										memRank: val.rank,
									}
								)
							}),
							netUtilisation: [{
								netFrom: '',
								netTo: '',
								netScore: '',
								netRank: '',
							}],
						});
					} else if (res.MetricName == "Network Response") {
						props.setFormData({
							Category: res.Category,
							Subcategory: res.subcategory,
							ApplicationName: res.MetricDesc,
							ApplicationType: res.ApplicationType,
							UrlPatterns: res.UrlPatters?.split(",")?.map((val: any) => { return ({ urlpattern: val }) }),
							ApplicationBinaries: res.SpecificInfo,
							cpuUtilisation: [{
								cpuFrom: '',
								cpuTo: '',
								cpuScore: '',
								cpuRank: '',
							}],
							memUtilisation: [{
								memFrom: '',
								memTo: '',
								memScore: '',
								memRank: '',
							}],
							netUtilisation: JSON.parse(res.Scores).range.map((val: any) => {
								return (
									{
										netFrom: val.from,
										netTo: val.to,
										netScore: val.sc,
										netRank: val.rank,
									}
								)
							}),
						});
					} else {
						props.setFormData({
							Category: '',
							Subcategory: '',
							ApplicationName: '',
							ApplicationType: '',
							UrlPatterns: [{
								// urlpatterns:''
							}],
							ApplicationBinaries: '',
							cpuUtilisation: [{
								cpuFrom: '',
								cpuTo: '',
								cpuScore: '',
								cpuRank: '',
							}],
							memUtilisation: [{
								memFrom: '',
								memTo: '',
								memScore: '',
								memRank: '',
							}],
							netUtilisation: [{
								netFrom: '',
								netTo: '',
								netScore: '',
								netRank: '',
							}],
						})
					}

					props.setDeviceName(res.Scope); 
					res.Scope === "All Device" && props.setallDevice(true);
				} else {
					props.func(data);
				}
			}else {
				props.func([]);
			}
		} catch (error) {
			console.log("getAppMonitoredList error=", error);
			props.func([]);
		}
	};

	const getAppMonitoredCnt = async (whereCondition: any) => {
		try {
			let data = await apiCall('/appmonitored/getAppMonitoredListCount', whereCondition);
			
			if (data.status === 'success' && data?.analytics_test_Scores?.length > 0) {
				props?.setAppData && props?.setAppData(data?.analytics_test_Scores)
				if (props.setRecordState) props.setRecordState(data.totalRecords);
				if (props.setRecordTotalPages) props.setRecordTotalPages(Math.ceil(data.totalRecords / 50));
				if (props.setTotalRecords) props.setTotalRecords(data.totalRecords);
				if (props.setTotalPages) props.setTotalPages(Math.ceil(data.totalRecords / 50));
			}else{
				props.func(data?.data);
			}
		} catch (error) {
			console.log("getAppMonitoredCnt error=", error);
		}
	}

	const deleteAppMonitored = async (ids: any) => {
		try {
			const {status} = await apiCall('/appmonitored/deleteAppMonitor', {id: ids, tenant: tenantName });
			
			if (status === 'success') {
				props.setIsToast(true);
				
				props?.setLoading(true);
			} else {
				props.setErrorToast(true);
        		props.setToastMessage(`${contextValue.selectedRowIdInTable?.length} Monitored ${contextValue.selectedRowIdInTable?.length > 1 ? 'Apps' : 'App'} deletion failed`);
			}
		} catch (error) {
			console.log("4d-=");

			props.setErrorToast(true);
        	props.setToastMessage(`${contextValue.selectedRowIdInTable?.length} Monitored ${contextValue.selectedRowIdInTable?.length > 1 ? 'Apps' : 'App'} deletion failed`);
		}

		contextValue.setSelectedRowIdInTable([]);

		setTimeout(() => {
			props.setDeleteAppMonitored(false);
		}, 1000);
	}

	const addAppMonitor = async (formdata: any, scoresData: any, tenant: string, devicename: string) => {
		try {
			delete formdata['cpuUtilisation'];
			delete formdata['memUtilisation'];
			delete formdata['netUtilisation'];
			
			formdata = {...formdata, scores: scoresData};

			console.log("func_formdata=", formdata);

			let {data, status} = await apiCall('/appmonitored/insertAppMonitored', {formdata, tenant, devicename});
			
			if (status === 'success') {
				props.setIsToast(true);
				props?.setLoading(true);
			}else{
				props.setErrorToast(true);
        		props.setToastMessage(`${formdata.ApplicationName} Monitored App creation failed`);
			}
		} catch (error) {
			console.log('addAppMonitor error=', error);

			props.setErrorToast(true);
        	props.setToastMessage(`${formdata.ApplicationName} Monitored App creation failed`);
		}

		props.setOverlayOpen(false);
		setTimeout(() => {
			props.setsaveBtnClicked(false);
		}, 2000);
	}

	const editMonitoredApp = async (formdata: any, tenant: string, devicename: string, id: any) => {
		try {
			let {data, status} = await apiCall('/appmonitored/editAppMonitored', {formdata, tenant, devicename, id});

			if (status === "success") {
				props.setIsToast(true);
				props?.setLoading(true);
			} else {
				props.setErrorToast(true);
        		props.setToastMessage(`${formdata.ApplicationName} Monitored App updation failed`);
			}
		} catch (error) {
			console.log('editMonitoredApp error=', error);

			props.setErrorToast(true);
        	props.setToastMessage(`${formdata.ApplicationName} Monitored App updation failed`);
		}

		props.setOverlayOpen(false);
		setTimeout(() => {
			props.setsaveBtnClicked(false);
		}, 2000);
	}

	const getExportData = async (condition: object, setExportDetails: any) => {
		try {
		  const { status, data } = await apiCall(`/appmonitored/getAppMonitoredList`, condition);
	
		  if (status === 'success' && data.length > 0) {
			setExportDetails(data);
		  } else {
			setExportDetails([]);
		  }
		} catch (error) {
		  console.log("appmonitored getExportData error=", error);
		  setExportDetails([]);
		}

		setTimeout(() => {
			props.setExportBtnClicked(false);
		}, 1000);
	}

	useEffect(() => {
		if (contextValue.selectedRowIdInTable.length > 0 && props.deleteAppMonitored) {
			deleteAppMonitored(contextValue.selectedRowIdInTable);
		}else if (props.searchVal.length > 0 && props.searchVal !== '') {
			getAppMonitoredList({ tenant: tenantName, search: props.searchVal, type: 'search' }, 50, parseInt(props.pageNo))
			getAppMonitoredCnt({ tenant: tenantName, search: props.searchVal, type: 'search' });
		} else if (props.isFilter) {
			getAppMonitoredList({ filter: props.filterArray, tenant: tenantName, type: 'filter' }, 50, parseInt(props.pageNo))
			getAppMonitoredCnt({ filter: props.filterArray, tenant: tenantName, type: 'filter' });
		} else if (!props.saveBtnClicked && props.overlayName === 'editMonitoredApp') {
			props.rowID !== undefined && getAppMonitoredList({ id: props.rowID }, null, null);
		} else if (props.isRefresh) {
			props.setIsRefresh(false);
			props.setRefreshToast(true);
			setTimeout(() => {
				props.setRefreshToast(false);
			}, 2000);
		} else if (props.exportBtnClicked) {
			getExportData({ function: 'export', types: 'data_collection', tenant: tenantName }, props.setExportDetails);
		} else if(props?.loading === undefined || props?.loading) {
			getAppMonitoredList(null, 50, parseInt(props.pageNo));
			getAppMonitoredCnt(null);
		}

		if (props.saveBtnClicked && props.overlayName === 'editMonitoredApp') {
			editMonitoredApp(props.formdata, tenantName, props.deviceName, props.rowID);
		} else if (props.saveBtnClicked && props.overlayName === 'addMonitoredApp') {
			addAppMonitor(props.formdata, props.scoresFormData, tenantName, props.deviceName);
		}
	}, [props.searchVal, props.pageNo, props.deleteAppMonitored, props.overlayName, props.rowID, props.isRefresh, props.isFilter, props.filterArray, props.exportBtnClicked]);
	
	return (<></>)
}